import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { BookingCustomerMainPhotoDialogComponent } from './dialogs/booking-customer-main-photo-dialog/booking-customer-main-photo-dialog.component';
import { VenueGalleryEditDialogComponent } from './dialogs/venue-gallery-edit-dialog/venue-gallery-edit-dialog.component';
import { SendVenueApplicationDialogComponent } from './dialogs/send-venue-application-dialog/send-venue-application-dialog.component';

@NgModule({
  declarations: [
    BookingCustomerMainPhotoDialogComponent,
    VenueGalleryEditDialogComponent,
    SendVenueApplicationDialogComponent
  ],
  imports: [CommonModule, ReactiveFormsModule, DynamicDialogModule],
  exports: [
    BookingCustomerMainPhotoDialogComponent,
    VenueGalleryEditDialogComponent,
    SendVenueApplicationDialogComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BookingCustomerSharedModule {}
